function VideoModal(url, title, description) {
    this.url = url;
    this.embedUrl = url.indexOf('youtube') > -1 ? 'https://www.youtube.com/embed/' + this.url.split('v=')[1] + '?autoplay=1&rel=0' : url;
    this.title = title;
    this.description = description;
    this.iframeEl = null;
    this.focusedElBeforeOpen = null;
    this.focusableEls = null;
    this.firstFocusableEl = null;
    this.lastFocusableEl = null;

    this.createStructure();
    this.addEventListeners();
    this.show();

    // Iframe aspect ratio
    this.setIframeAspectRatio();
    window.addEventListener('resize', _ => this.setIframeAspectRatio());
    window.addEventListener('orientationchange', _ => this.setIframeAspectRatio());
};

VideoModal.prototype.createStructure = function() {
    this.el = document.createElement('div');
    this.el.classList.add('video-modal');
    this.el.classList.add('jsCloseModal');
    this.el.ariaHidden = true;

    let string = '';

    string += '<button type="button" class="video-modal__close-btn jsCloseModal">Sluiten</button>';
    string += '<div class="video-modal__inner">';
        if (this.title || this.description) {
            string += '<div class="video-modal__title-wrapper">';
                if (this.title) string += '<span class="title heading-2">' + this.title + '</span>';
                if (this.description) string += '<span class="description">' + this.description + '</span>';
            string += '</div>';
        }

        string += '<div class="video-modal__iframe-wrapper"><iframe src="' + this.embedUrl + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
    string += '</div>';

    this.el.innerHTML = string;

    this.iframeEl = this.el.querySelector('iframe');

    // Add the modal to the body
    document.body.appendChild(this.el);

    // Accessibility stuff
    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, iframe, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
};

VideoModal.prototype.addEventListeners = function() {
    this.keyUpEvent = this.handleKeyupEvent.bind(this);
    this.keyDownEvent = this.handleKeydownEvent.bind(this);
    this.keyUpEvent = this.handleClickEvent.bind(this);

    window.addEventListener('keyup', this.keyUpEvent);
    window.addEventListener('keydown', this.keyDownEvent);
    this.el.addEventListener('click', this.keyUpEvent);
};

VideoModal.prototype.removeEventListeners = function() {
    window.removeEventListener('keyup', this.keyUpEvent);
    window.removeEventListener('keydown', this.keyDownEvent);
    this.el.removeEventListener('click', this.keyUpEvent);
};

VideoModal.prototype.handleKeyupEvent = function(e) {
    if (e.key.toLowerCase() === 'escape') {
        this.hide();
    }
};

VideoModal.prototype.handleKeydownEvent = function(e) {
    const tabIsPressed = e.key === 'Tab';

    if (!tabIsPressed) return;

    if (e.shiftKey) {
        if (document.activeElement === this.firstFocusableEl) {
            this.lastFocusableEl.focus();
            e.preventDefault();
        }
    }
    else {
        if (document.activeElement === this.lastFocusableEl) {
            this.firstFocusableEl.focus();
            e.preventDefault();
        }
    }
};

VideoModal.prototype.handleClickEvent = function(e) {
    if (e.target.classList.contains('jsCloseModal')) {
        this.hide();
    }
};

VideoModal.prototype.show = function() {
    document.body.classList.add('no-overflow');
    this.el.classList.add('visible');

    this.setIframeAspectRatio();

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
    if (this.firstFocusableEl) this.firstFocusableEl.focus();
};

VideoModal.prototype.hide = function() {
    // Set classes
    document.body.classList.remove('no-overflow');
    this.el.classList.remove('visible');

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    this.focusedElBeforeOpen = null;
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;

    // Delete
    this.el.parentElement.removeChild(this.el);
    this.removeEventListeners();
};

VideoModal.prototype.setIframeAspectRatio = function() {
    const aspectRatio = [16, 9];

    this.iframeEl.style.width = null;
    this.iframeEl.style.height = null;

    let newWidth = this.iframeEl.parentElement.offsetWidth;
    let newHeight = Math.min(((this.iframeEl.parentElement.offsetWidth / aspectRatio[0]) * aspectRatio[1]), window.innerHeight * 0.8);

    this.iframeEl.style.width = newWidth + 'px';
    this.iframeEl.style.height = newHeight + 'px';
};

(function() {
    window.addEventListener('click', e => {
        if (e.target.classList.contains('jsVideoModalTrigger')) {
            e.preventDefault();
            new VideoModal(e.target.dataset.videoModalUrl, e.target.dataset.videoModalTitle, e.target.dataset.videoModalDesc);
        }
    });
})();